import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import * as uuid from 'uuid';
import DropDownColumn from "./DropDownColumn";
import NumberColumn from "./NumberColumn";
import TextColumn from "./TextColumn";
import Paginacion from "./Paginacion";
import "./styles.scss";
import SimpleErrorMessage from 'components/InputsMex/containers/SimpleErrorMessage';

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * @typedef {object} Column
 * @property {any} value
 * @property {boolean} hasError
 * @property {string} errorMessage
 *
 * @typedef {object} Row
 * @property {boolean} loading
 * @property {string} uuid
 * @property {Column} equipo
 * @property {Column} suma
 *
 * @param {*} props
 * @returns
 */
const EditableTable = (props) => {
  const { wsOptions, rows, setRows, titleTable = 'Desglose de Equipos', infoAdicional = false, validacionesAdicionales={},bloquearBeneficiario=false } = props;
  /** @type {[Row[], (row:Row[])=>void]} */
  // const [rows, setRows] = useState([]);
  const [options, setOptions] = useState([]);
  /** @type {[page:number,(page:number)=>void]} */
  const [page, setPage] = useState(1);

  const chunkSize = 10;
  const [minWidthTable, setMinWithTable] = useState('300px');
  const [minWidthTable1, setMinWithTable1] = useState('250px');
  const [defaultClassDiv, setDefaultClassDiv] = useState('col-12 d-flex flex-row align-items-center justify-content-center table-background');
  const [defaultClassTable, setDefaultClassTable] = useState('table table-responsive-xl separated-rows');

  useEffect(() => {
    setOptions(wsOptions);
    if (infoAdicional) {
      setMinWithTable('300px')
      setMinWithTable1('150px')
      setDefaultClassDiv('col-12 table-background class-overflow-table')
      setDefaultClassTable('table separated-rows w-100')
    }
  }, []);

  /** @type {Row[][]} */
  const chunkedRows = useMemo(() => _.chunk(rows, chunkSize), [rows, chunkSize]);

  const onClickAgregar = () => {
    setPage(1);
    setRows([
      {
        uuid: uuid.v4(),
        equipo: {
          value: null,
          hasError: false,
          errorMessage: "",
          skipValidation:true
        },
        suma: {
          value: null,
          hasError: false,
          skipValidation:true
        },
      },
      ...rows,
    ]);
  };

  //  const validarEquipo = (/** @type {Row} */ row) => {
  //     row.equipo.hasError = false;
  //     row.equipo.errorMessage = null;
  //     if (!row?.equipo?.value) {
  //       row.equipo.hasError = true;
  //       row.equipo.errorMessage = "Este campo es obligatorio";
  //     }
  //     return row;
  //   };

  //   const validarSuma = (/** @type {Row} */ row) => {
  //     row.suma.hasError = false;
  //     row.suma.errorMessage = null;
  //     if (!row?.suma?.value) {
  //       row.suma.hasError = true;
  //       row.suma.errorMessage = "Este campo es obligatorio";
  //     }
  //     return row;
  //   };

  const changeRows = (/** @type {Row[]} */ newRows) => setRows([...newRows]);

  const onClickEliminar = (row, index) => () => {
    setRows(rows?.filter((item) => item.uuid !== row.uuid));
  };

  // const onClickGuardar = (/** @type {Row} */ row, index) => () => {
  //   row = validarEquipo(row);
  //   row = validarSuma(row);
  //   if (row?.equipo?.hasError || row?.suma?.hasError) {
  //     rows[index] = row;
  //     return changeRows(rows);
  //   }
  //   rows[index].loading = true;
  //   changeRows(rows);
  //   setTimeout(() => {
  //     rows[index].loading = false;
  //     rows[index].id = uuid.v4();
  //     changeRows(rows);
  //   }, 2000);
  // };

  const onChangeEquipo = (/** @type {Row} */ row, index) => (value) => {
    row.equipo.value = value;
    row.equipo.skipValidation = false;
    //rows[index] = validarEquipo(row);    
    changeRows(rows);
  };

  const onChangeSuma = (/** @type {Row} */ row, index) => (value) => {
    row.suma.value = value;
    row.suma.skipValidation = false;
    //rows[index] = validarSuma(row);
    changeRows(rows);
  };

  // const validarRequired = (row, name) => {
  //   row[name].hasError = false;
  //   row[name].errorMessage = null;
  //   if (!row?.[name]?.value) {
  //     row[name].hasError = true;
  //     row[name].errorMessage = "Este campo es obligatorio";
  //   }
  //   return row;
  // }

  // const validarNumber = (row, name) => {
  //   row[name].hasError = false;
  //   row[name].errorMessage = null;
  //   if(isNaN(+row?.[name]?.value))
  //    {
  //     row[name].hasError = true;
  //     row[name].errorMessage = "Este campo es solo numeros";
  //   }
  //   return row;
  // }

const onChangeText = (/** @type {Row} */ row, index, name, validador = null) => (value) => {  
    if (!row?.[name]) {
    row[name]={}
    }
    row[name].value = value;
    row[name].skipValidation = false;
    if (validador) {
      rows[index] = validador(row, name)
    }
    changeRows(rows);
  };

  return (
    <React.Fragment>
      <div className='container-fluid'>
        <div className='row my-5'>
          <div className='row col-12 col-md-8 title-table'>{titleTable} </div>
          {!infoAdicional &&
            <div className='row col-12 col-md-4 justify-content-end'>
              <button
                className="btn-add"
                onClick={onClickAgregar}
              >
                + Agregar Equipo
              </button>
            </div>
          }

          <div className='col-12 d-flex flex-row align-items-center justify-content-center table-background' style={{ marginBottom: '0px', textAlign: "center", paddingTop: '12px' }}>
            <br /><SimpleErrorMessage name={'datosMaquinaria'} fontSize={'19px'} />
          </div>
          <div className={defaultClassDiv}>
            <table className={defaultClassTable}>
              <thead className='border-0 center'>
                <tr className='border-0'>
                  <th className="style-th" style={{ textAlign: "left" }}></th>
                  <th className="style-th" style={{ minWidth: `${minWidthTable}`, textAlign: "left" }}>Descripción del equipo</th>
                  {infoAdicional &&
                    <React.Fragment>
                      <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Marca</th>
                      <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Modelo</th>
                      <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Nro. de serie</th>
                      <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Año</th>
                    </React.Fragment>
                  }
                  <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Suma asegurada</th>
                  {infoAdicional &&
                    <React.Fragment>
                      <th className="style-th" style={{ minWidth: `${minWidthTable1}`, textAlign: "left" }}>Beneficiario</th>
                    </React.Fragment>
                  }
                  {!infoAdicional &&
                    <th style={{ width: `${minWidthTable1}` }}>
                      {/* <i className='pi pi-cog' /> */}
                    </th>
                  }

                </tr>
              </thead>
              <tbody className='text-center'>
                {chunkedRows?.[page - 1]?.map?.((row, chunkIndex) => {
                  const realPage = page === 1 ? 0 : page - 1;
                  const index = realPage * chunkSize + chunkIndex;
                  return (
                    <tr key={row.uuid}>
                      <td className='border v-center background-white'>{index + 1}</td>
                      <DropDownColumn
                        value={row?.equipo?.value}
                        hasError={row?.equipo?.hasError}
                        errorMessage={row?.equipo?.errorMessage}
                        onChange={onChangeEquipo(row, index)}
                        options={options}
                        disabled={row?.disabled || row?.loading || infoAdicional}
                        placeholder={"SELECCIONAR.."}
                      />
                      {infoAdicional &&
                        <React.Fragment>
                          <TextColumn
                            value={row?.marca?.value}
                            hasError={row?.marca?.hasError}
                            errorMessage={row?.marca?.errorMessage}
                            disabled={false}
                            onChange={onChangeText(row, index, 'marca')}
                          />
                          <TextColumn
                            value={row?.modelo?.value}
                            hasError={row?.modelo?.hasError}
                            errorMessage={row?.modelo?.errorMessage}
                            disabled={false}
                            onChange={onChangeText(row, index, 'modelo')}
                          />
                          <TextColumn
                            value={row?.serie?.value}
                            hasError={row?.serie?.hasError}
                            errorMessage={row?.serie?.errorMessage}
                            disabled={false}
                            onChange={onChangeText(row, index, 'serie')}
                            maxLength={validacionesAdicionales?.validacionSerie?.maxLength}
                          />
                          <TextColumn
                            value={row?.anio?.value}
                            hasError={row?.anio?.hasError}
                            errorMessage={row?.anio?.errorMessage}
                            disabled={false}
                            onChange={onChangeText(row, index, 'anio')}
                            maxLength={validacionesAdicionales?.validacionAnio?.maxLength || 4}
                          />
                        </React.Fragment>
                      }
                      <NumberColumn
                        value={row?.suma?.value}
                        hasError={row?.suma?.hasError}
                        errorMessage={row?.suma?.errorMessage}
                        onChange={onChangeSuma(row, index)}
                        disabled={row?.disabled || row?.loading || infoAdicional}
                      />
                      {infoAdicional &&
                        <React.Fragment>
                          <TextColumn
                            value={row?.beneficiario?.value}
                            hasError={row?.beneficiario?.hasError}
                            errorMessage={row?.beneficiario?.errorMessage}
                            disabled={bloquearBeneficiario}
                            onChange={onChangeText(row, index, 'beneficiario')}
                          />
                        </React.Fragment>
                      }

                      {!infoAdicional &&
                        <td className='v-center size-button-content'>
                          <div className='d-flex flex-row justify-content-around'>
                            {/* <button
                              className="btn-save"
                              onClick={onClickGuardar(row, index)}
                              disabled={row.loading}>
                              Guardar
                            </button> */}
                            <button
                              className="btn-delete"
                              onClick={onClickEliminar(row, index)}
                              disabled={row.loading}>
                              Eliminar
                            </button>
                          </div>
                        </td>

                      }

                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>          
          <div className='col-12 d-flex flex-row justify-content-center back-pagination'>
            <Paginacion
              size='md'
              page={page}
              setPage={setPage}
              pages={chunkedRows?.length}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
EditableTable.defaultProps = {
  rows: []
}
export default EditableTable;
